class BaseAction {
    constructor(data) {
        this.type = data.type;
    }
}

export default BaseAction;